<template>
  <table>
    <tbody>
      <tr v-for="(tax, index) in taxes" :key="index">
        <td>
          <i>
            <arrival-tax-translation :tax-name="tax.name" />
          </i>
        </td>
        <td>
          <pu-price :price="tax.amount" :display-original-price="true" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { ChargeTypeArrivalTax } from '../../../../campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class ArrivalTax extends Vue {
  @Prop()
  taxes: ChargeTypeArrivalTax[]
}

export default toNative(ArrivalTax)
</script>

<style scoped>
i {
  font-style: italic;
}
</style>
